import naja from 'naja';
import NetteForms from 'nette-forms';

export default class PaymentMethodSelect {
    static init(): void {
        PaymentMethodSelect.initInputs();
        PaymentMethodSelect.handleZipInput();

        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (
                event.detail.snippet.id.includes('snippet-orderMethodsForm-methods') ||
                event.detail.snippet.id.includes('snippet-orderMethodsForm-payments')
            ) {
                PaymentMethodSelect.initInputs();
                PaymentMethodSelect.handleZipInput();
                NetteForms.initOnLoad();
            }
        });
    }

    private static initInputs(): void {
        const form = document.querySelector('form.jsPaymentForm') as HTMLFormElement | null;
        if (!form) return;

        const items = form.querySelectorAll('.base-payment-method__item-content');
        items.forEach((item) => {
            const clone = item.cloneNode(true) as HTMLElement;
            item.parentNode?.replaceChild(clone, item);

            clone.addEventListener('click', (e: Event) => {
                const target = e.target as HTMLElement;

                // Don't interfere with links, buttons, or extra section inputs
                if (target.closest('a') || target.closest('button') || target.closest('.base-payment-method__extra')) {
                    return;
                }

                const radio = clone.querySelector('input[type="radio"]') as HTMLInputElement | null;
                if (!radio || radio.checked) return;

                radio.checked = true;

                if (radio.name === 'delivery_product_id') {
                    form.dataset.selectedBranch = 'false';
                }

                naja.uiHandler.submitForm(form);
            });
        });
    }

    private static handleZipInput(): void {
        const input = document.querySelector('.zip-input') as HTMLInputElement | null;
        if (!input) return;

        input.addEventListener('input', () => {
            window.clearTimeout(Number(input.dataset.timeout));
            input.dataset.timeout = String(
                setTimeout(() => {
                    const form = document.querySelector('#frm-orderMethodsForm-paymentForm') as HTMLFormElement;
                    if (form) {
                        naja.uiHandler.submitForm(form);
                    }
                }, 800),
            );
        });
    }
}
